import { Button, SectionHeader, Text } from "@ttc3k/trekker";
import { PropsWithChildren } from "react";
import { Flex, FlexProps } from "styled-system/jsx";
import { ForwardRefExoticComponent, RefAttributes, SVGProps } from "react";

type ViewSubSectionProps = FlexProps &
  PropsWithChildren & {
    title: string;
    Icon?: ForwardRefExoticComponent<
      Omit<SVGProps<SVGSVGElement>, "ref"> & RefAttributes<SVGSVGElement>
    >;
    description?: string;
    buttonLabel?: string;
    onButtonClick?: () => void;
    disableButton?: boolean;
    buttonOverride?: React.ReactNode;
  };

export const ViewSubSection = ({
  title,
  Icon,
  description,
  children,
  buttonLabel,
  onButtonClick,
  disableButton = false,
  buttonOverride,
  ...rest
}: ViewSubSectionProps) => {
  return (
    <Flex flexDir={"column"} gap={"250"} {...rest}>
      <SectionHeader text={title} Icon={Icon} divider>
        {buttonOverride ? (
          buttonOverride
        ) : buttonLabel && onButtonClick ? (
          <Button
            size={"sm"}
            visual={"primary"}
            mode={"light"}
            onClick={onButtonClick}
            disabled={disableButton}
          >
            {buttonLabel}
          </Button>
        ) : null}
      </SectionHeader>
      {description && <Text color={"text.mid"}>{description}</Text>}
      {children}
    </Flex>
  );
};
